export const ArrowRighWithLine = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g id='ic-arrow-back-24px 1' clipPath='url(#clip0_553_53425)'>
      <path
        id='Vector'
        d='M2.66634 7.33464H10.7797L7.05301 3.60797L7.99967 2.66797L13.333 8.0013L7.99967 13.3346L7.05967 12.3946L10.7797 8.66797H2.66634V7.33464Z'
        fill='#94A3B8'
      />
    </g>
    <defs>
      <clipPath id='clip0_553_53425'>
        <rect width='16' height='16' fill='white' transform='matrix(-1 0 0 1 16 0)' />
      </clipPath>
    </defs>
  </svg>
);
